"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var core_1 = require("@formily/core");
var context_1 = __importDefault(require("../context"));
var react_eva_1 = require("react-eva");
var shared_1 = require("../shared");
function useFormEffects(effects) {
    var form = react_1.useContext(context_1.default);
    var dispatch = react_eva_1.useEva({
        effects: shared_1.createFormEffects(effects, form)
    }).dispatch;
    var subscribeId = react_1.useMemo(function () {
        return form.subscribe(function (_a) {
            var type = _a.type, payload = _a.payload;
            dispatch.lazy(type, function () {
                return core_1.isStateModel(payload) ? payload.getState() : payload;
            });
        });
    }, []);
    react_1.useEffect(function () {
        return function () {
            form.unsubscribe(subscribeId);
        };
    }, []);
}
exports.useFormEffects = useFormEffects;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@formily/react/lib/hooks/useFormEffects.js
// module id = 5770
// module chunks = 0